// src/app/shared/services/datepicker-change.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DatepickerChangeService {
  private dateChangeSubject = new Subject<{ value: Date; id?: string }>();
  dateChange$ = this.dateChangeSubject.asObservable();

  emitChange(value: Date, id?: string) {
    this.dateChangeSubject.next({ value, id });
  }
}
